import config from "../config.js";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchLatestUserInfo = async () => {
  try {
    const response = await fetch(`${config.serverUri}/private/users/info`, {
      credentials: "include",
    });

    if (!response.ok) return null;

    return response.json();
  } catch (error) {
    console.error("결제 확인을 위한 사용자 정보 조회 실패:", error);
    return null;
  }
};

// 서버의 실제 로우 증가를 확인할 때까지 폴링한다. 확인 실패 시 false.
export const waitForCreditCharge = async ({
  creditBefore,
  lowCount,
  timeoutMs = 15000,
  intervalMs = 1000,
}) => {
  if (creditBefore == null || !lowCount) return false;

  const deadline = Date.now() + timeoutMs;

  while (Date.now() < deadline) {
    const latestUserInfo = await fetchLatestUserInfo();
    const latestCreditAmount = Number(latestUserInfo?.creditAmount);

    if (
      Number.isFinite(latestCreditAmount) &&
      latestCreditAmount >= creditBefore + lowCount
    ) {
      return true;
    }

    await delay(intervalMs);
  }

  return false;
};
